import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Transaction } from '../cik/cik.service';

@Injectable({
  providedIn: 'root'
})
export class DetailsService {
  detailsSubject$ = new BehaviorSubject<any>({});

  onRowSelected(row: any) {
    this.detailsSubject$.next(row);
  }
}
